/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для поля изменения города на странице списка менеджеров.
   */
  app.ChoiceCityContactsItemView = app.View.extend({
    el: '.contacts-list_pseudo-popup',

    'events': {
      'blur .choice-city_input': 'blurInputCity',
      'click .choice-city_wrapper-input label': 'clearInput',
      'focus .choice-city_input': 'clearInput',
    },
  
    /**
     * @inheritDoc
     */
    run: function () {
      this.cityInput = this.$('.choice-city_input');
      this.contactSettlement = this.settlement.clone().set('isSaveForUser', false);
      this.listenTo(this.contactSettlement, 'sync', this.getManagers);
      this.listenTo(this.settlement, 'change:name', this.getManagers);
      var autocomplete = new app.SettlementAutocompleteView({
          el: this.cityInput,
          settlement: this.contactSettlement,
        }),
        that = this;
      autocomplete.$el.autocomplete({
        appendTo: that.$('.choice-city_autocomplete'),
        open: function () {
          that.trigger('autocompleteOpen', null);
        },
        select: function (event, ui) {
          that.changeSettlement(ui.item.id);
          /**
           * Сохранение названия города и области
           */
          that.cityInput.data('settlement-name', ui.item.label);
          return false;
        },
      });
      this.listenTo(autocomplete, 'autocompleteOpen', this.openPopup);
      this.listenTo(autocomplete, 'autocompleteDone', this.closePopup);
    },

    openPopup: function () {
      this.$el.addClass('active');
    },
    closePopup: function () {
      this.$el.removeClass('active');
    },

    /**
     * Изменяет текст города
     * @param {app.settlementForm} model
     */
    changeCityText: function (model) {
      var nameAndRegion = model.get('name') + ' (' + model.get('region') + ')';
      this.cityInput.val(nameAndRegion);

      this.closePopup();
    },

    /**
     * Изменение текста и перерендер менеджеров
     * @param {app.settlementForm} model
     */
    getManagers: function (model) {
      this.changeCityText(model);
      this.trigger('settlement-changed', model);
    },

    /**
     * При потере фокуса полем ввода города, скрываем псевдопопап.
     */
    blurInputCity: function () {
      this.changeCityText(this.contactSettlement);
    },
  
    /**
     * Изменяет текущий город
     * @param {Number} id
     */
    changeSettlement: function (id) {
      this.contactSettlement.save({'settlement_id': id});
    },

    /**
     * Очищает поле города
     */
    clearInput: function () {
      this.cityInput.val('');
    },
  });
})();

}.call(window));